import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import Layout from "./components/layouts/layout";
import Dashboard from "./components/HelpDesk/Dashboard";
import ClientManagement from "./components/HelpDesk/ClientManagement";
import ServiceOperations from "./components/HelpDesk/ServiceOperations";
import Help from "./components/HelpDesk/Help";
import Account from "./components/HelpDesk/Account";
import NewIssueForm from "./components/HelpDesk/NewIssueForm";
import ClientProfile from "./components/HelpDesk/ClientProfile";
import LoginPage from "./components/login/LoginPage";
import OTPPage from "./components/login/OTPPage";
import Tasks from "./components/Client/Tasks";
import ClientCreateIssue from "./components/Client/c_createIssue";
import ClientDashboard from "./components/Client/c_dashboard";
import ClientFinance from "./components/Client/c_finance";
import config from "./config";
import Schedule from "./components/Client/Schedule";
import TSOScheduleViewer from "./components/HelpDesk/TSOScheduleViewer";
import ManagementDashboard from './components/Admin/ManagementDashboard';
import ReferralOnlineTSO from './components/HelpDesk/referral_Online_tso';
import ReferralClient from './components/Client/referrals_client'; 
import Location from './components/Admin/Location';
import Invoice from './components/Admin/Invoice';
import AllInvoice from './components/Admin/All_Invoice';
import PreviosReferral from './components/HelpDesk/PreviousReferrals';
import PreviosReferralClient from './components/Client/PreviousReferrals_client';
import TsoManagement from './components/Admin/TSOManagement';
import ClientManage from './components/Admin/ClientManagement';
import CreateClient from './components/Admin/CreateClient';
import Ticket from './components/Admin/Tickets';
import Schedules from "./components/Admin/Schedules";
import DocumentManagement from "./components/Admin/DocumentManagement";
import OnsitePayments from "./components/Admin/OnsitePayments";
import TSOExpensesManagement from "./components/Admin/TSOExpensesManagement";
import DSManagement from "./components/Admin/DsManagement";
import CustomerServiceProgress from "./components/Admin/CustomerServiceProgress";
import ServiceProgressForm from "./components/Admin/ServiceProgressForm";

const useAuth = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userType, setUserType] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = Cookies.get("authToken");
    const type = Cookies.get("userType");
    const userId = Cookies.get("userId");

    if (token && type && userId) {
      validateToken(token).then(() => {
        setIsLoggedIn(true);
        setUserType(type);
      }).catch(() => {
        logout();
      }).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const validateToken = async (token) => {
    try {
      const response = await fetch(`${config.API_URL}/auth/validate-token`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      if (!data.valid) {
        throw new Error("Token is not valid");
      }
    } catch (error) {
      console.error("Token validation error:", error);
      throw error;
    }
  };

  const loginHandler = (token, type, userId) => {
    if (token && type && userId) {
      Cookies.set("authToken", token, { expires: 365, path: "/" });
      Cookies.set("userType", type, { expires: 365, path: "/" });
      Cookies.set("userId", userId, { expires: 365, path: "/" });
      setUserType(type);
      setIsLoggedIn(true);
    }
  };

  const logout = () => {
    setIsLoggedIn(false);
    setUserType(null);
    Cookies.remove("authToken");
    Cookies.remove("userType");
    Cookies.remove("userId");
  };

  return { isLoggedIn, userType, loginHandler, logout, loading };
};

const App = () => {
  const { isLoggedIn, userType, loginHandler, logout, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <div className="app-container">
        {isLoggedIn ? (
          <Routes>
            {["TSO Online", "Online TSO"].includes(userType) ? (
              <Route path="/" element={<Layout setIsLoggedIn={logout} />}>
                <Route index element={<Navigate to="dashboard" />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="client-management" element={<ClientManagement />} />
                <Route path="client-profile/:id" element={<ClientProfile />} />
                <Route path="service-operations" element={<ServiceOperations />} />
                <Route path="TSOScheduleViewer" element={<TSOScheduleViewer />} />
                <Route path="new-issue" element={<NewIssueForm />} />
                <Route path="help" element={<Help />} />
                <Route path="account" element={<Account setIsLoggedIn={logout} />} />
                <Route path="referrals" element={<ReferralOnlineTSO />} /> 
                <Route path="previous-referrals" element={<PreviosReferral />} />
              </Route>
            ) : userType === "management" ? (
              <Route path="/" element={<Layout setIsLoggedIn={logout} />}>
                <Route index element={<Navigate to="management-dashboard" />} />
                <Route path="management-dashboard" element={<ManagementDashboard />} />
                <Route path="management-tso-location" element={<Location/>} />
                <Route path="invoice" element={<Invoice/>} />
                <Route path="all-invoice" element={<AllInvoice/>} />
                <Route path="help" element={<Help />} />
                <Route path="account" element={<Account />} />
                <Route path = "tso-management" element={<TsoManagement />} />
                <Route path = "client-manage" element={<ClientManage />} />
                <Route path = "create-client" element={<CreateClient />} />
                <Route path = "tickets-managment" element={<Ticket />} />
                <Route path = "schedule-managment" element={<Schedules />} />
                <Route path = "document-managment" element={<DocumentManagement />} />
                <Route path = "onsite-payments-managment" element={<OnsitePayments />} />
                <Route path = "tso-expenses-managment" element={<TSOExpensesManagement />} />
                <Route path = "ds-managment" element={<DSManagement />} />
                <Route path = "customer-service-progress" element={<CustomerServiceProgress />} />
                <Route path = "service-progress-form" element={<ServiceProgressForm />} />
              </Route>
            ) : (
              <Route path="/" element={<Layout setIsLoggedIn={logout} />}>
                <Route index element={<Navigate to="c-dashboard" />} />
                <Route path="c-dashboard" element={<ClientDashboard />} />
                <Route path="Tasks" element={<Tasks />} />
                <Route path="create-issue" element={<ClientCreateIssue />} />
                <Route path="help" element={<Help />} />
                <Route path="account" element={<Account />} />
                <Route path="schedules/:selectedDate" element={<Schedule />} />
                <Route path="finance" element={<ClientFinance />} />
                <Route path="referrals" element={<ReferralClient />} /> 
                <Route path="previous-referrals-client" element={<PreviosReferralClient />} />
              </Route>
            )}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        ) : (
          <Routes>
            <Route path="/" element={<LoginPage loginHandler={loginHandler} />} />
            <Route path="/OTPPage" element={<OTPPage loginHandler={loginHandler} />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        )}
      </div>
    </Router>
  );
};

export default App;